import { useSetPageMeta } from '../../../hooks/usePageMeta';
import OptimizerAuditLog from './OptimizerAuditLog';

export default function AuditLogPage() {
  useSetPageMeta({
    title: 'Optimizer Audit Log',
    description: 'Review automated campaign optimization actions',
  });

  return (
    <div className="space-y-6">
      <OptimizerAuditLog />
    </div>
  );
}
